import { QuizQuestion } from '../../types';

export const regexModule2QuestionBank: QuizQuestion[] = [
  // Character Classes Basics (25 questions)
  {
    id: 'q001',
    question: 'What does [abc] match in regex?',
    choices: [
      'The literal string "abc"',
      'Any one of the characters a, b, or c',
      'All characters a, b, and c in sequence',
      'Any character except a, b, or c',
    ],
    correctAnswer: 1,
    explanation:
      '[abc] is a character class that matches any single character that is either a, b, or c.',
  },
  {
    id: 'q002',
    question: 'What does [^abc] match?',
    choices: [
      'The start of a line followed by abc',
      'Any character except a, b, or c',
      'Any one of the characters a, b, or c',
      "Nothing - it's invalid syntax",
    ],
    correctAnswer: 1,
    explanation:
      '[^abc] is a negated character class. The ^ inside square brackets means "not", so it matches any character except a, b, or c.',
  },
  {
    id: 'q003',
    question: 'What does [a-z] match?',
    choices: [
      'The literal string "a-z"',
      'Any lowercase letter from a to z',
      'Any letter, uppercase or lowercase',
      'Any character between a and z in ASCII',
    ],
    correctAnswer: 1,
    explanation: '[a-z] uses a range to match any single lowercase letter from a to z.',
  },
  {
    id: 'q004',
    question: 'What does [A-Z] match?',
    choices: [
      'Any uppercase letter from A to Z',
      'Any lowercase letter from a to z',
      'Any letter, uppercase or lowercase',
      'The literal string "A-Z"',
    ],
    correctAnswer: 0,
    explanation: '[A-Z] matches any single uppercase letter from A to Z.',
  },
  {
    id: 'q005',
    question: 'What does [0-9] match?',
    choices: [
      'Numbers from 0 to 9',
      'Any single digit from 0 to 9',
      'The literal string "0-9"',
      'Any numeric value',
    ],
    correctAnswer: 1,
    explanation: '[0-9] matches any single digit character from 0 to 9.',
  },
  {
    id: 'q006',
    question: 'What does [a-zA-Z] match?',
    choices: [
      'Only lowercase letters',
      'Only uppercase letters',
      'Any letter, both uppercase and lowercase',
      'The literal string "a-zA-Z"',
    ],
    correctAnswer: 2,
    explanation:
      '[a-zA-Z] combines two ranges to match any single letter, whether uppercase or lowercase.',
  },
  {
    id: 'q007',
    question: 'What does [a-zA-Z0-9] match?',
    choices: [
      'Any alphanumeric character',
      'Only letters',
      'Only numbers',
      'The literal string "a-zA-Z0-9"',
    ],
    correctAnswer: 0,
    explanation:
      '[a-zA-Z0-9] matches any single alphanumeric character - letters (upper or lower case) or digits.',
  },
  {
    id: 'q008',
    question: 'How do you match a literal hyphen (-) inside a character class?',
    choices: [
      'Put it at the beginning or end: [-abc] or [abc-]',
      'Escape it: [a\\-c]',
      'Both A and B work',
      'You cannot match a literal hyphen',
    ],
    correctAnswer: 2,
    explanation:
      'You can match a literal hyphen by placing it at the start/end of the character class or by escaping it with a backslash.',
  },
  {
    id: 'q009',
    question: 'What does [aeiou] match?',
    choices: [
      'The word "aeiou"',
      'Any vowel (a, e, i, o, u)',
      'All vowels in sequence',
      'Any character except vowels',
    ],
    correctAnswer: 1,
    explanation: '[aeiou] matches any single vowel character.',
  },
  {
    id: 'q010',
    question: 'What does [^0-9] match?',
    choices: [
      'Any digit',
      'Any non-digit character',
      'Numbers from 0 to 9',
      'The start of a line followed by digits',
    ],
    correctAnswer: 1,
    explanation:
      '[^0-9] is a negated character class that matches any character that is not a digit.',
  },
  {
    id: 'q011',
    question: 'What does [.,!?;] match?',
    choices: [
      'Any punctuation mark in the list',
      'The literal string ".,!?;"',
      'Any sentence ending',
      'Multiple punctuation marks',
    ],
    correctAnswer: 0,
    explanation:
      '[.,!?;] matches any single punctuation character listed: period, comma, exclamation, question mark, or semicolon.',
  },
  {
    id: 'q012',
    question: 'What does [ \\t\\n] match?',
    choices: [
      'Any whitespace character',
      'Spaces, tabs, and newlines only',
      'The literal characters space, t, n',
      'Any invisible character',
    ],
    correctAnswer: 1,
    explanation:
      '[ \\t\\n] matches any single character that is a space, tab (\\t), or newline (\\n).',
  },
  {
    id: 'q013',
    question: 'How do you match a literal square bracket ] inside a character class?',
    choices: [
      'Escape it: [\\]]',
      'Put it at the beginning: []abc]',
      'Both A and B work',
      'You cannot match a literal ]',
    ],
    correctAnswer: 2,
    explanation:
      'You can match a literal ] by escaping it [\\]] or by placing it at the very beginning of the character class []abc].',
  },
  {
    id: 'q014',
    question: 'What does [A-z] match?',
    choices: [
      'Any letter, uppercase or lowercase',
      'Any character from A to z in ASCII table',
      'Only uppercase letters',
      'Invalid syntax',
    ],
    correctAnswer: 1,
    explanation:
      '[A-z] matches characters from ASCII A (65) to z (122), which includes letters and some punctuation like [, \\, ], ^, _, `.',
  },
  {
    id: 'q015',
    question: 'What does [0-9a-f] match?',
    choices: [
      'Hexadecimal digits (0-9, a-f)',
      'Only digits',
      'Only letters a through f',
      'Any alphanumeric character',
    ],
    correctAnswer: 0,
    explanation:
      '[0-9a-f] matches any single character that is either a digit (0-9) or lowercase letter a through f, covering lowercase hexadecimal digits.',
  },
  {
    id: 'q016',
    question: 'What does [^a-zA-Z] match?',
    choices: ['Any letter', 'Any non-letter character', 'Only punctuation', 'Only numbers'],
    correctAnswer: 1,
    explanation:
      '[^a-zA-Z] matches any character that is not a letter, including digits, punctuation, whitespace, etc.',
  },
  {
    id: 'q017',
    question: 'What does [\\d] match?',
    choices: [
      'The letter d',
      'Any digit (equivalent to [0-9])',
      'A literal backslash followed by d',
      'Invalid syntax',
    ],
    correctAnswer: 1,
    explanation:
      '[\\d] inside a character class still means any digit. The brackets are redundant here since \\d is already a character class.',
  },
  {
    id: 'q018',
    question: 'What does [] match?',
    choices: [
      'Any character',
      'Nothing - empty character class',
      'A literal empty string',
      'Whitespace only',
    ],
    correctAnswer: 1,
    explanation:
      '[] is an empty character class that cannot match anything. Most regex engines treat this as an error.',
  },
  {
    id: 'q019',
    question: 'What does [a-z-] match?',
    choices: [
      'Lowercase letters and hyphen',
      'Invalid syntax',
      'Letters from a to z minus something',
      'Only lowercase letters',
    ],
    correctAnswer: 0,
    explanation:
      '[a-z-] matches any lowercase letter or a literal hyphen. The hyphen at the end is treated literally, not as a range operator.',
  },
  {
    id: 'q020',
    question: 'What does [a-c-x] match?',
    choices: [
      'Letters a, b, c, and x',
      'Letters from a to c, and letters from c to x',
      'Invalid syntax due to double hyphen',
      'Letters a, b, c, hyphen, and x',
    ],
    correctAnswer: 3,
    explanation:
      '[a-c-x] matches letters a, b, c, a literal hyphen, and the letter x. The first hyphen creates range a-c, the second is literal.',
  },
  {
    id: 'q021',
    question: 'What does [\\w] match?',
    choices: [
      'The letter w',
      'Any word character (letters, digits, underscore)',
      'Any whitespace',
      'A literal backslash and w',
    ],
    correctAnswer: 1,
    explanation:
      '[\\w] matches any word character. The brackets are redundant since \\w is already a character class shorthand.',
  },
  {
    id: 'q022',
    question: 'What does [\\s] match?',
    choices: [
      'The letter s',
      'Any whitespace character',
      'Any special character',
      'A literal backslash and s',
    ],
    correctAnswer: 1,
    explanation:
      '[\\s] matches any whitespace character. The brackets are redundant since \\s is already a character class shorthand.',
  },
  {
    id: 'q023',
    question: 'What does [abc\\d] match?',
    choices: [
      'Letters a, b, c, and the letter d',
      'Letters a, b, c, and any digit',
      'The literal string "abc\\d"',
      'Invalid syntax',
    ],
    correctAnswer: 1,
    explanation:
      '[abc\\d] matches any single character that is either a, b, c, or any digit (0-9). The \\d expands to include all digits.',
  },
  {
    id: 'q024',
    question: 'What does [^\\d] match?',
    choices: [
      'Any digit',
      'Any non-digit character',
      'The literal string "^\\d"',
      'Start of line followed by digits',
    ],
    correctAnswer: 1,
    explanation:
      '[^\\d] is a negated character class that matches any character that is not a digit.',
  },
  {
    id: 'q025',
    question: 'What does [a-z&&[^aeiou]] match in some regex flavors?',
    choices: [
      'Any letter',
      'Only vowels',
      'Only consonants (lowercase letters except vowels)',
      'Invalid syntax',
    ],
    correctAnswer: 2,
    explanation:
      '[a-z&&[^aeiou]] uses character class intersection (in Java/Unicode regex) to match lowercase letters that are not vowels, i.e., consonants.',
  },

  // Predefined Character Classes (25 questions)
  {
    id: 'q026',
    question: 'What does \\d match?',
    choices: ['The letter d', 'Any digit from 0 to 9', 'Any decimal number', 'Double characters'],
    correctAnswer: 1,
    explanation:
      '\\d is a predefined character class that matches any single digit from 0 to 9, equivalent to [0-9].',
  },
  {
    id: 'q027',
    question: 'What does \\D match?',
    choices: ['Any digit', 'Any non-digit character', 'The letter D', 'Double digits'],
    correctAnswer: 1,
    explanation:
      '\\D is the negated version of \\d, matching any character that is not a digit, equivalent to [^0-9].',
  },
  {
    id: 'q028',
    question: 'What does \\w match?',
    choices: [
      'Any word',
      'Any word character (letters, digits, underscore)',
      'Any whitespace',
      'The letter w',
    ],
    correctAnswer: 1,
    explanation:
      '\\w matches any word character: letters (a-z, A-Z), digits (0-9), and underscore (_), equivalent to [a-zA-Z0-9_].',
  },
  {
    id: 'q029',
    question: 'What does \\W match?',
    choices: ['Any word character', 'Any non-word character', 'Any word boundary', 'The letter W'],
    correctAnswer: 1,
    explanation:
      '\\W is the negated version of \\w, matching any character that is not a word character, equivalent to [^a-zA-Z0-9_].',
  },
  {
    id: 'q030',
    question: 'What does \\s match?',
    choices: [
      'The letter s',
      'Any whitespace character (space, tab, newline, etc.)',
      'Any special character',
      'Any string',
    ],
    correctAnswer: 1,
    explanation:
      '\\s matches any whitespace character including space, tab (\\t), newline (\\n), carriage return (\\r), form feed (\\f), and vertical tab (\\v).',
  },
  {
    id: 'q031',
    question: 'What does \\S match?',
    choices: [
      'Any whitespace character',
      'Any non-whitespace character',
      'The letter S',
      'Any special character',
    ],
    correctAnswer: 1,
    explanation:
      '\\S is the negated version of \\s, matching any character that is not whitespace.',
  },
  {
    id: 'q032',
    question:
      'Which predefined character class would you use to match any letter, digit, or underscore?',
    choices: ['\\d', '\\w', '\\s', '\\a'],
    correctAnswer: 1,
    explanation:
      '\\w (word character) matches letters, digits, and underscore, making it perfect for matching typical programming identifiers.',
  },
  {
    id: 'q033',
    question: 'Which predefined character class would you use to match spaces, tabs, and newlines?',
    choices: ['\\w', '\\d', '\\s', '\\b'],
    correctAnswer: 2,
    explanation:
      '\\s (whitespace) matches all types of whitespace characters including spaces, tabs, and newlines.',
  },
  {
    id: 'q034',
    question: 'What is the equivalent character class for \\d?',
    choices: ['[0-9]', '[a-z]', '[A-Z]', '[0-9a-z]'],
    correctAnswer: 0,
    explanation: '\\d is equivalent to [0-9] - it matches any single digit character.',
  },
  {
    id: 'q035',
    question: 'What is the equivalent character class for \\w?',
    choices: ['[a-zA-Z]', '[0-9]', '[a-zA-Z0-9_]', '[a-z_]'],
    correctAnswer: 2,
    explanation: '\\w is equivalent to [a-zA-Z0-9_] - it matches letters, digits, and underscore.',
  },
  {
    id: 'q036',
    question: 'What pattern would match any character that is NOT a digit?',
    choices: ['\\d', '\\D', '[^d]', '!\\d'],
    correctAnswer: 1,
    explanation: '\\D matches any non-digit character, equivalent to [^0-9].',
  },
  {
    id: 'q037',
    question: 'What pattern would match any character that is NOT a word character?',
    choices: ['\\w', '\\W', '[^w]', '!\\w'],
    correctAnswer: 1,
    explanation: '\\W matches any non-word character, equivalent to [^a-zA-Z0-9_].',
  },
  {
    id: 'q038',
    question: 'What pattern would match any character that is NOT whitespace?',
    choices: ['\\s', '\\S', '[^s]', '!\\s'],
    correctAnswer: 1,
    explanation: '\\S matches any non-whitespace character.',
  },
  {
    id: 'q039',
    question:
      'Which pattern would match a typical variable name in programming (starts with letter or underscore)?',
    choices: ['\\w+', '[a-zA-Z_]\\w*', '\\d\\w*', '[A-Z]\\w*'],
    correctAnswer: 1,
    explanation:
      '[a-zA-Z_]\\w* matches a letter or underscore followed by zero or more word characters, which is typical for variable names.',
  },
  {
    id: 'q040',
    question: 'What does the pattern \\d\\d\\d match?',
    choices: [
      'Any three-digit number',
      'The letter d three times',
      'Three digits in sequence',
      'Any number with three digits',
    ],
    correctAnswer: 2,
    explanation:
      '\\d\\d\\d matches exactly three digit characters in sequence, like "123" or "456".',
  },
  {
    id: 'q041',
    question: 'What does the pattern \\w\\s\\w match?',
    choices: [
      'Any word separated by space',
      'A word character, whitespace, then another word character',
      'Two words with space between',
      'Word, space, word',
    ],
    correctAnswer: 1,
    explanation:
      '\\w\\s\\w matches exactly one word character, followed by one whitespace character, followed by one word character.',
  },
  {
    id: 'q042',
    question: 'What does \\s+ match?',
    choices: [
      'One or more whitespace characters',
      'The letter s one or more times',
      'A plus sign after whitespace',
      'Exactly one whitespace character',
    ],
    correctAnswer: 0,
    explanation:
      '\\s+ matches one or more consecutive whitespace characters. The + is a quantifier meaning "one or more".',
  },
  {
    id: 'q043',
    question: 'What does \\D+ match?',
    choices: [
      'One or more digits',
      'One or more non-digit characters',
      'The letter D one or more times',
      'Any number',
    ],
    correctAnswer: 1,
    explanation: '\\D+ matches one or more consecutive non-digit characters.',
  },
  {
    id: 'q044',
    question: 'What does \\W+ match?',
    choices: [
      'One or more word characters',
      'One or more non-word characters',
      'The letter W one or more times',
      'Any word',
    ],
    correctAnswer: 1,
    explanation:
      '\\W+ matches one or more consecutive non-word characters (punctuation, spaces, etc.).',
  },
  {
    id: 'q045',
    question: 'Which pattern would match common whitespace between words?',
    choices: ['\\s', '\\s+', '[ \\t]+', 'Both B and C'],
    correctAnswer: 3,
    explanation:
      'Both \\s+ (one or more whitespace) and [ \\t]+ (one or more spaces or tabs) can match whitespace between words.',
  },
  {
    id: 'q046',
    question: 'What does [\\d\\s] match?',
    choices: [
      'Digits and whitespace only',
      'Any single character that is either a digit or whitespace',
      'Digits followed by whitespace',
      'The literal characters d and s',
    ],
    correctAnswer: 1,
    explanation:
      '[\\d\\s] is a character class that matches any single character that is either a digit or a whitespace character.',
  },
  {
    id: 'q047',
    question: 'What does [\\w\\s] match?',
    choices: [
      'Word characters and whitespace',
      'Any single character that is either a word character or whitespace',
      'Words separated by spaces',
      'The literal characters w and s',
    ],
    correctAnswer: 1,
    explanation:
      '[\\w\\s] matches any single character that is either a word character (letter, digit, underscore) or whitespace.',
  },
  {
    id: 'q048',
    question: 'What does [^\\d\\s] match?',
    choices: [
      'Digits and whitespace',
      'Any character except digits and whitespace',
      'Non-digits and non-whitespace',
      'The literal characters d and s',
    ],
    correctAnswer: 1,
    explanation:
      '[^\\d\\s] is a negated character class that matches any character that is neither a digit nor whitespace.',
  },
  {
    id: 'q049',
    question:
      'Which pattern would match a single character that could be part of an email address?',
    choices: ['[\\w@.-]', '[\\w@.\\-]', '[a-zA-Z0-9@.-]', 'All of the above'],
    correctAnswer: 3,
    explanation:
      'All patterns would match characters commonly found in email addresses, though they have slight differences in syntax.',
  },
  {
    id: 'q050',
    question: "What's the main advantage of using \\d instead of [0-9]?",
    choices: [
      '\\d is faster',
      '\\d is more concise and readable',
      '\\d matches more characters',
      'There is no advantage',
    ],
    correctAnswer: 1,
    explanation:
      '\\d is more concise and readable than [0-9], making regex patterns shorter and easier to understand.',
  },

  // Quantifiers (25 questions)
  {
    id: 'q051',
    question: 'What does the * quantifier mean?',
    choices: [
      'Exactly one occurrence',
      'Zero or more occurrences',
      'One or more occurrences',
      'Zero or one occurrence',
    ],
    correctAnswer: 1,
    explanation: 'The * quantifier means "zero or more occurrences" of the preceding element.',
  },
  {
    id: 'q052',
    question: 'What does the + quantifier mean?',
    choices: [
      'Zero or more occurrences',
      'One or more occurrences',
      'Zero or one occurrence',
      'Exactly one occurrence',
    ],
    correctAnswer: 1,
    explanation: 'The + quantifier means "one or more occurrences" of the preceding element.',
  },
  {
    id: 'q053',
    question: 'What does the ? quantifier mean?',
    choices: [
      'Zero or more occurrences',
      'One or more occurrences',
      'Zero or one occurrence (optional)',
      'Any number of occurrences',
    ],
    correctAnswer: 2,
    explanation:
      'The ? quantifier means "zero or one occurrence", making the preceding element optional.',
  },
  {
    id: 'q054',
    question: 'What does a* match?',
    choices: [
      'One or more "a" characters',
      'Zero or more "a" characters',
      'Exactly one "a" character',
      'The literal string "a*"',
    ],
    correctAnswer: 1,
    explanation: 'a* matches zero or more consecutive "a" characters: "", "a", "aa", "aaa", etc.',
  },
  {
    id: 'q055',
    question: 'What does a+ match?',
    choices: [
      'Zero or more "a" characters',
      'One or more "a" characters',
      'Exactly one "a" character',
      'The literal string "a+"',
    ],
    correctAnswer: 1,
    explanation:
      'a+ matches one or more consecutive "a" characters: "a", "aa", "aaa", etc., but not an empty string.',
  },
  {
    id: 'q056',
    question: 'What does a? match?',
    choices: [
      'Zero or more "a" characters',
      'One or more "a" characters',
      'Zero or one "a" character',
      'Any character',
    ],
    correctAnswer: 2,
    explanation: 'a? matches either zero or one "a" character, making "a" optional.',
  },
  {
    id: 'q057',
    question: 'What does \\d+ match?',
    choices: [
      'Exactly one digit',
      'One or more digits',
      'Zero or more digits',
      'Any digit followed by plus sign',
    ],
    correctAnswer: 1,
    explanation: '\\d+ matches one or more consecutive digits, like "1", "23", "456", etc.',
  },
  {
    id: 'q058',
    question: 'What does \\d* match?',
    choices: [
      'One or more digits',
      'Zero or more digits',
      'Exactly one digit',
      'Any number of any characters',
    ],
    correctAnswer: 1,
    explanation: '\\d* matches zero or more consecutive digits, including an empty string.',
  },
  {
    id: 'q059',
    question: 'What does \\d? match?',
    choices: [
      'Zero or more digits',
      'One or more digits',
      'Zero or one digit',
      'Any optional character',
    ],
    correctAnswer: 2,
    explanation: '\\d? matches either zero or one digit, making a single digit optional.',
  },
  {
    id: 'q060',
    question: 'What does [abc]+ match?',
    choices: [
      'The letters a, b, and c in sequence',
      'One or more characters from the set {a, b, c}',
      'Exactly one character from a, b, or c',
      'The literal string "[abc]+"',
    ],
    correctAnswer: 1,
    explanation:
      '[abc]+ matches one or more consecutive characters where each character is either a, b, or c.',
  },
  {
    id: 'q061',
    question: 'What does [abc]* match?',
    choices: [
      'One or more characters from {a, b, c}',
      'Zero or more characters from the set {a, b, c}',
      'Exactly one character from a, b, or c',
      'Any characters except a, b, c',
    ],
    correctAnswer: 1,
    explanation:
      '[abc]* matches zero or more consecutive characters where each character is either a, b, or c.',
  },
  {
    id: 'q062',
    question: 'What does [abc]? match?',
    choices: [
      'Zero or more characters from {a, b, c}',
      'One or more characters from {a, b, c}',
      'Zero or one character from the set {a, b, c}',
      'Any optional character',
    ],
    correctAnswer: 2,
    explanation: '[abc]? matches either zero or one character from the set {a, b, c}.',
  },
  {
    id: 'q063',
    question: 'What does .* match?',
    choices: [
      'Any single character',
      'Zero or more of any character',
      'One or more of any character',
      'A literal dot and asterisk',
    ],
    correctAnswer: 1,
    explanation:
      '.* matches zero or more of any character (except newline by default), often used to match "anything".',
  },
  {
    id: 'q064',
    question: 'What does .+ match?',
    choices: [
      'Zero or more of any character',
      'One or more of any character',
      'Any single character',
      'A literal dot and plus sign',
    ],
    correctAnswer: 1,
    explanation:
      '.+ matches one or more of any character (except newline by default), ensuring at least one character is present.',
  },
  {
    id: 'q065',
    question: 'What does .? match?',
    choices: [
      'Zero or more of any character',
      'One or more of any character',
      'Zero or one of any character',
      'Any optional character',
    ],
    correctAnswer: 2,
    explanation: '.? matches zero or one of any character, making any single character optional.',
  },
  {
    id: 'q066',
    question: 'What does \\w+ match in "hello world"?',
    choices: [
      '"hello world" (the entire string)',
      '"hello" and "world" separately',
      'Just "hello"',
      'Individual word characters',
    ],
    correctAnswer: 1,
    explanation:
      '\\w+ matches sequences of word characters. In "hello world", it would match "hello" and "world" as separate matches.',
  },
  {
    id: 'q067',
    question: 'What does \\s+ match in "hello    world"?',
    choices: [
      'Each individual space',
      'The sequence of spaces between words',
      'Just the first space',
      'All characters',
    ],
    correctAnswer: 1,
    explanation:
      '\\s+ matches one or more consecutive whitespace characters, so it would match the entire sequence of spaces between "hello" and "world".',
  },
  {
    id: 'q068',
    question: 'What does abc+ match?',
    choices: [
      'The string "abc" one or more times',
      '"ab" followed by one or more "c" characters',
      'One or more of any character in "abc"',
      'The literal string "abc+"',
    ],
    correctAnswer: 1,
    explanation:
      'abc+ matches "ab" followed by one or more "c" characters: "abc", "abcc", "abccc", etc.',
  },
  {
    id: 'q069',
    question: 'What does (abc)+ match?',
    choices: [
      '"ab" followed by one or more "c" characters',
      'The string "abc" repeated one or more times',
      'One or more of any character in "abc"',
      'The literal string "(abc)+"',
    ],
    correctAnswer: 1,
    explanation:
      '(abc)+ matches the entire string "abc" repeated one or more times: "abc", "abcabc", "abcabcabc", etc.',
  },
  {
    id: 'q070',
    question: 'What does colou?r match?',
    choices: [
      'Only "colour"',
      'Only "color"',
      'Both "color" and "colour"',
      'The literal string "colou?r"',
    ],
    correctAnswer: 2,
    explanation:
      'colou?r matches both "color" and "colour" because the "u" is optional (zero or one occurrence).',
  },
  {
    id: 'q071',
    question: 'What does \\d{3} match?',
    choices: [
      'One or more digits',
      'Zero or more digits',
      'Exactly three digits',
      'Up to three digits',
    ],
    correctAnswer: 2,
    explanation: '\\d{3} uses exact quantifier syntax to match exactly three consecutive digits.',
  },
  {
    id: 'q072',
    question: 'What does \\d{2,4} match?',
    choices: [
      'Exactly two or four digits',
      'Between two and four digits (inclusive)',
      'Two digits followed by four digits',
      'At least two digits',
    ],
    correctAnswer: 1,
    explanation:
      '\\d{2,4} matches between 2 and 4 consecutive digits (inclusive): 2, 3, or 4 digits.',
  },
  {
    id: 'q073',
    question: 'What does \\d{3,} match?',
    choices: [
      'Exactly three digits',
      'At most three digits',
      'At least three digits',
      'Three or more digits',
    ],
    correctAnswer: 2,
    explanation: "\\d{3,} matches three or more consecutive digits - there's no upper limit.",
  },
  {
    id: 'q074',
    question: 'What does \\w{1,} match?',
    choices: [
      'Exactly one word character',
      'One or more word characters',
      'At most one word character',
      'Any word character',
    ],
    correctAnswer: 1,
    explanation: '\\w{1,} matches one or more word characters, which is equivalent to \\w+.',
  },
  {
    id: 'q075',
    question: 'What does \\w{0,} match?',
    choices: [
      'No word characters',
      'Zero or more word characters',
      'Any word characters',
      'At most zero word characters',
    ],
    correctAnswer: 1,
    explanation: '\\w{0,} matches zero or more word characters, which is equivalent to \\w*.',
  },

  // Advanced Character Classes and Quantifiers (25 questions)
  {
    id: 'q076',
    question: 'What does [a-z]{2,8} match?',
    choices: [
      'Any lowercase word between 2 and 8 letters',
      '2 to 8 consecutive lowercase letters',
      'Exactly 2 or 8 lowercase letters',
      'Any word with lowercase letters',
    ],
    correctAnswer: 1,
    explanation: '[a-z]{2,8} matches between 2 and 8 consecutive lowercase letters.',
  },
  {
    id: 'q077',
    question: 'What does [A-Z][a-z]+ match?',
    choices: [
      'Any word with mixed case',
      'A word starting with uppercase, followed by lowercase letters',
      'Only proper nouns',
      'Any capitalized word',
    ],
    correctAnswer: 1,
    explanation:
      '[A-Z][a-z]+ matches one uppercase letter followed by one or more lowercase letters, like "Hello" or "World".',
  },
  {
    id: 'q078',
    question: 'What does [0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3} match?',
    choices: ['Any decimal number', 'IP address format (basic)', 'Version numbers', 'Coordinates'],
    correctAnswer: 1,
    explanation:
      'This pattern matches the basic structure of an IP address: 1-3 digits, dot, 1-3 digits, dot, 1-3 digits, dot, 1-3 digits.',
  },
  {
    id: 'q079',
    question: 'What does [a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,} match?',
    choices: [
      'Any string with @ symbol',
      'Basic email address format',
      'Domain names only',
      'Social media handles',
    ],
    correctAnswer: 1,
    explanation:
      'This is a basic email validation pattern matching local part, @, domain, dot, and top-level domain.',
  },
  {
    id: 'q080',
    question: 'What does \\(?\\d{3}\\)?[-.]?\\d{3}[-.]?\\d{4} match?',
    choices: [
      'Any number',
      'Phone number in various formats',
      'Social security numbers',
      'Credit card numbers',
    ],
    correctAnswer: 1,
    explanation:
      'This pattern matches phone numbers with optional parentheses around area code and optional separators: (123)456-7890, 123.456.7890, etc.',
  },
  {
    id: 'q081',
    question: 'What does [^\\s]+ match?',
    choices: [
      'Any whitespace',
      'One or more non-whitespace characters',
      'Any word',
      'Any character except letters',
    ],
    correctAnswer: 1,
    explanation:
      '[^\\s]+ matches one or more consecutive non-whitespace characters, effectively matching "words" or tokens.',
  },
  {
    id: 'q082',
    question: 'What does \\d+\\.?\\d* match?',
    choices: [
      'Only integers',
      'Only decimal numbers',
      'Both integers and decimal numbers',
      'Only numbers with decimal points',
    ],
    correctAnswer: 2,
    explanation:
      '\\d+\\.?\\d* matches one or more digits, optionally followed by a decimal point and zero or more digits, matching both "123" and "123.45".',
  },
  {
    id: 'q083',
    question: 'What does [A-Z]{2,4} match?',
    choices: [
      'State abbreviations',
      '2 to 4 consecutive uppercase letters',
      'Country codes',
      'All of the above could be matched',
    ],
    correctAnswer: 3,
    explanation:
      '[A-Z]{2,4} matches 2 to 4 consecutive uppercase letters, which could represent state codes, country codes, or other abbreviations.',
  },
  {
    id: 'q084',
    question: 'What does \\w+\\s+\\w+ match?',
    choices: [
      'Any two words',
      'One or more word chars, whitespace, one or more word chars',
      'Exactly two words separated by one space',
      'First and last names',
    ],
    correctAnswer: 1,
    explanation:
      '\\w+\\s+\\w+ matches one or more word characters, followed by one or more whitespace characters, followed by one or more word characters.',
  },
  {
    id: 'q085',
    question: 'What does [a-z]+@[a-z]+\\.[a-z]{2,3} match?',
    choices: [
      'Any email address',
      'Simple email addresses with lowercase letters only',
      'Domain names',
      'Usernames',
    ],
    correctAnswer: 1,
    explanation:
      'This matches basic email addresses where all parts are lowercase letters, like "user@domain.com" or "test@site.org".',
  },
  {
    id: 'q086',
    question: 'What does #[0-9A-Fa-f]{6} match?',
    choices: ['Any hashtag', 'Hexadecimal color codes', 'HTML tags', 'Social media posts'],
    correctAnswer: 1,
    explanation: '#[0-9A-Fa-f]{6} matches hexadecimal color codes like #FF0000, #3A5FCD, etc.',
  },
  {
    id: 'q087',
    question: 'What does \\$\\d+\\.\\d{2} match?',
    choices: [
      'Any number with dollar sign',
      'Currency amounts in dollars and cents',
      'Decimal numbers',
      'Prices',
    ],
    correctAnswer: 1,
    explanation:
      '\\$\\d+\\.\\d{2} matches dollar amounts with exactly two decimal places, like $123.45 or $9.99.',
  },
  {
    id: 'q088',
    question: 'What does [12]\\d{3} match?',
    choices: [
      'Any four-digit number',
      'Years from 1000-2999',
      'Numbers starting with 1 or 2',
      'Four-digit numbers starting with 1 or 2',
    ],
    correctAnswer: 3,
    explanation:
      '[12]\\d{3} matches four-digit numbers starting with 1 or 2, like 1234, 2021, etc.',
  },
  {
    id: 'q089',
    question: 'What does \\w{3,12} match?',
    choices: [
      'Words between 3 and 12 characters',
      '3 to 12 consecutive word characters',
      'Usernames',
      'All of the above could apply',
    ],
    correctAnswer: 3,
    explanation:
      '\\w{3,12} matches 3 to 12 consecutive word characters, which could represent usernames, short words, etc.',
  },
  {
    id: 'q090',
    question: 'What does [aeiou]{2,} match?',
    choices: [
      'Any vowel',
      'Two or more consecutive vowels',
      'Words with multiple vowels',
      'Exactly two vowels',
    ],
    correctAnswer: 1,
    explanation: '[aeiou]{2,} matches two or more consecutive vowels, like "ea", "oo", "aaa", etc.',
  },
  {
    id: 'q091',
    question: 'What does [^aeiouAEIOU\\s]+ match?',
    choices: [
      'Any consonant',
      'One or more consecutive consonants (non-vowels, non-spaces)',
      'Words without vowels',
      'Consonant clusters',
    ],
    correctAnswer: 1,
    explanation:
      '[^aeiouAEIOU\\s]+ matches one or more consecutive characters that are not vowels or spaces, effectively matching consonant sequences.',
  },
  {
    id: 'q092',
    question: 'What does \\d{2}/\\d{2}/\\d{4} match?',
    choices: ['Any date format', 'MM/DD/YYYY date format', 'Fractions', 'File paths'],
    correctAnswer: 1,
    explanation: '\\d{2}/\\d{2}/\\d{4} matches dates in MM/DD/YYYY format, like 12/25/2023.',
  },
  {
    id: 'q093',
    question: 'What does [A-Z][a-z]{1,9} match?',
    choices: [
      'Proper nouns',
      'One uppercase letter followed by 1-9 lowercase letters',
      'Names',
      'All of the above could apply',
    ],
    correctAnswer: 3,
    explanation:
      '[A-Z][a-z]{1,9} matches one uppercase letter followed by 1-9 lowercase letters, which could represent names, proper nouns, etc.',
  },
  {
    id: 'q094',
    question: 'What does \\w*@\\w*\\.\\w{2,4} match?',
    choices: [
      'Email addresses including edge cases',
      'Domain names',
      'Social media handles',
      'Web URLs',
    ],
    correctAnswer: 0,
    explanation:
      '\\w*@\\w*\\.\\w{2,4} matches email-like patterns, including edge cases like "@domain.com" (empty local part).',
  },
  {
    id: 'q095',
    question: 'What does [0-9a-fA-F]{4,8} match?',
    choices: [
      'Hexadecimal numbers',
      '4 to 8 character hexadecimal values',
      'Color codes',
      'All of the above could apply',
    ],
    correctAnswer: 3,
    explanation:
      '[0-9a-fA-F]{4,8} matches 4 to 8 hexadecimal characters, which could represent hex numbers, color codes, memory addresses, etc.',
  },
  {
    id: 'q096',
    question: 'What does \\s*,\\s* match?',
    choices: [
      'Any comma',
      'A comma with optional surrounding whitespace',
      'Multiple commas',
      'CSV separators',
    ],
    correctAnswer: 1,
    explanation:
      '\\s*,\\s* matches a comma with zero or more whitespace characters before and after it, useful for parsing CSV or lists.',
  },
  {
    id: 'q097',
    question: 'What does [a-zA-Z]+\\s[a-zA-Z]+ match?',
    choices: [
      'Any two words',
      'First and last names',
      'Two words separated by space',
      'All of the above could apply',
    ],
    correctAnswer: 3,
    explanation:
      '[a-zA-Z]+\\s[a-zA-Z]+ matches two sequences of letters separated by space, which could represent names, two words, etc.',
  },
  {
    id: 'q098',
    question: 'What does \\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4} match?',
    choices: [
      'Phone numbers in multiple formats',
      'Social security numbers',
      'Any number sequence',
      'Credit card numbers',
    ],
    correctAnswer: 0,
    explanation:
      'This flexible pattern matches phone numbers in various formats: (123) 456-7890, 123-456-7890, 123.456.7890, etc.',
  },
  {
    id: 'q099',
    question: 'What does [\\w._%+-]+@[\\w.-]+\\.[a-zA-Z]{2,} match?',
    choices: [
      'Basic email addresses',
      'Advanced email validation pattern',
      'Domain names',
      'Web addresses',
    ],
    correctAnswer: 1,
    explanation:
      'This is a more comprehensive email pattern that allows dots, percent signs, and plus signs in the local part, and hyphens in the domain.',
  },
  {
    id: 'q100',
    question: "What's the most important consideration when using quantifiers in regex?",
    choices: [
      'Always use the shortest quantifier',
      'Always use the longest quantifier',
      'Choose quantifiers based on your specific matching needs',
      "Quantifiers don't matter much",
    ],
    correctAnswer: 2,
    explanation:
      'The choice of quantifiers should be based on your specific needs: use + when you need at least one, * when zero is acceptable, ? for optional elements, and {n,m} for specific ranges.',
  },
];
